import { isNil } from "./is"

export function ensure<T>(value: T | undefined | null, error?: string | Error | (() => Error)): T {
  if (isNil(value)) {
    if (typeof error === "string") {
      throw new Error(error)
    }

    if (error instanceof Error) {
      throw error
    }

    if (typeof error === "function") {
      throw error()
    }

    throw new Error("Value not found")
  }

  return value
}
